module.exports = __webpack_public_path__ + "static/media/ph_beaker_2.89361217.svg";